import Picture from './Picture';
export default Picture;
